import React from 'react';

interface TickerProps {
  items: string[];
  
  repeat?: number;
  speed?: number; 
}

export default function Ticker({ items, repeat = 3, speed = 30 }: TickerProps) {
  const track = Array.from({ length: repeat }, () => items).flat();

  return (
    <div className="hero__ticker">
      <div
        className="hero__ticker-track"
        style={{ animationDuration: `${speed}s` }}
      >
        {track.map((item, i) => (
          <span key={i} className="hero__ticker-item">
            <span className="hero__ticker-dot" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
